import { render, staticRenderFns } from "./Nosologia.vue?vue&type=template&id=d33b84b4&"
import script from "./Nosologia.vue?vue&type=script&lang=js&"
export * from "./Nosologia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports